/**
 * Imports
*/

// utils
import lang from '../../misc/i18n.js';
import InstabergUtils from '../../misc/utils.js';

/**
 * WordPress dependencies
*/
const { __, _n, sprintf } = wp.i18n;
const { Component, render, findDOMNode, Fragment } = wp.element;

/**
 * Config
*/
const localizationName = 'instaberg';
const alias = 'AAInstaberg-View-';



/**
 * React Components
*/
class InstabergViewCreative2_ListItem extends Component {

  constructor(props) {
    super(props);

    this.state = {
      isHovered: false
    };
  }

  render()
  {
    let { isHovered } = this.state;
    let isHoveredCss = isHovered ? `${alias}hover-state` : '';

    const { video } = this.props;
    let { image, total_comments, total_likes, caption, link, post_type } = video;

    const styleGridImg = {
      backgroundImage: `url(${image})`,
    };

    total_likes = 'undefined' === typeof total_likes ? 0 : total_likes;
    total_likes = InstabergUtils.humanFormat( total_likes );

    total_comments = 'undefined' === typeof total_comments ? 0 : total_comments;
    total_comments = InstabergUtils.humanFormat( total_comments );
    
    return (
      <div
        className={ `${alias}element` }
        data-key={ video.id }
        onMouseEnter={ (e) => { this.handleMenuHover( e ) } }
        onMouseLeave={ (e) => { this.handleMenuHover( e ) } }
        onClick={ (e) => { this.handleMenuClick( e, { videoid: video.id, image, post_type } ) } }
      >
        <a href={ link } className={ `${alias}creative2-img-url` }>
          <span className={ `${alias}img` }>
            { '' !== image ? <img src={ image } /> : '' }
            { InstabergUtils.itemShowIcon( post_type ) }
          </span>
        </a>

        <div
          style={ isHovered ? this.props.pcstyle[0] : {} }
          className={ `${alias}overlay ${isHoveredCss}` }
        >
          <div className={ `${alias}creative2-description` }>

            <div className={ `${alias}creative2-misc` }>

              <span className={ `${alias}misc-likes` }>
                <a href={ link } target="_blank" style={{ fontFamily: this.props.pcstyle[1].fontFamily }}><i className="mi-icon mi-icon-heart5"></i>{ total_likes }</a>
              </span>
              <span className={ `${alias}misc-comments` }>
                <a href={ link } target="_blank" style={{ fontFamily: this.props.pcstyle[1].fontFamily }}><i className="mi-icon mi-icon-bubble"></i>{ total_comments }</a>
              </span>

            </div>

            <div className={ `${alias}creative2-info` }>
              <p style={ this.props.pcstyle[1] }>
                { caption }
              </p>
            </div>

          </div>
        </div>

      </div>
    );
  }

  handleMenuHover( event )
  {
    this.setState({
      isHovered: ! this.state.isHovered
    });
  }

  handleMenuClick( event, pms )
  {
    event.preventDefault();
    this.props.onClickListItem( pms );
  }
}

class InstabergViewCreative2 extends Component {

  constructor(props) {
    super(props);
  }

  render()
  {
    return ( this.PrintVideosList() );
  }

  PrintVideoSingleElement( video )
  {
    let pcstyle = [{
      background: this._get_option('primaryColor')['main_color'],
    }, {
      color: this._get_option('primaryColor')['text_color'],
      fontFamily: this._get_option('primaryColor')['font_family'],
      fontSize: `${this._get_option('primaryColor')['font_size']}px`,
    }];

    return (
      <InstabergViewCreative2_ListItem
        pcstyle={ pcstyle }
        video={ video }
        onClickListItem={ (pms) => { this.props.onClickListItem( pms ) } }
      />
    );
  }

  PrintVideosList()
  {
    const { layoutType } = this.props.options;
    let { videos } = this.props;
    const creative2GridCols = parseInt( this._get_option('creative2GridCols') );

    if ( ! videos.length ) {
      return '';
    }

    const video_list = videos.map( video => {
      return ( this.PrintVideoSingleElement( video ) );
    });

    return (
      <React.Fragment>
        <div
          className={ `${alias}creative2-grid ${alias}creative2-${creative2GridCols}col` }
        >
          { video_list }
        </div>
      </React.Fragment>
    );
  }

  //============================================================================================
  // MISC
  _get_option( opt_name )
  {
    let options = this.props.options;

    let opt = null;
    if ( InstabergUtils.isset( options, opt_name ) ) {
      opt = options[ opt_name ];
    }
    return opt;
  }

}
export { InstabergViewCreative2 };



// WEBPACK FOOTER //
// ./wp-content/plugins/instaberg/src/templates/creative2/tpl.view.js